(function () {
    'use strict';

    angular
        .module('BCMControllers')
        .controller('BIAProfileSummaryController', Controller);

    Controller.$inject = ['$scope', 'biaSummaryContainer', 'followUps', 'bcmLookups'];

    function Controller($scope, biaSummaryContainer, followUps, bcmLookups) {

        $scope.biaProfile = biaSummaryContainer.BIAProfile;
        $scope.biaBUOwnersContainer = biaSummaryContainer.BIABUOwnersContainer;
        $scope.followUps = followUps;
        $scope.bcmLookups = bcmLookups;
        $scope.canValidate = biaSummaryContainer.HasBIAProfile_Head_Validate;
        $scope.canReject = biaSummaryContainer.HasBIAProfile_BUOwner_Reject;
    }
})();